import { Field } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';

const ExpenseCategoryField = ({ data, checkIn, index, num, crew }) => {
    const calculateMinDate = () => {
        if (data?.key === 'CheckOut' && checkIn) {
            return checkIn;
        }
        return '';
    };
    return (
        <>
            <Field
                name={`purchaseOrderCrew[${index}].categoryDetails[${num}].value`}
                component={InputFieldComponent}
                disabled={crew?.isShortClosed || crew?.airfareStatus === 1
                    || crew?.serviceStatus
                    || crew?.invoiceStatus?.toLowerCase().includes('payment')
                    || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                    || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                className="w-full"
                rounded
                type={data?.type}
                label={data?.label}
                min={calculateMinDate()}
            />
        </>
    );
};

const ExpenseFieldForm = ({ id, expenseCategoryList, checkIn, checkOut, index, crew }) => {
    const [NoOfdays, setNoOfdays] = useState('');
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (checkIn) {
            setNoOfdays('');
            if (checkOut) {
                const startDate = moment(checkIn);
                const endDate = moment(checkOut);
                const days = endDate.diff(startDate, 'days');
                setNoOfdays(days);
            }
        }
    }, [checkIn, checkOut]);
    const category = expenseCategoryList?.find(
        ({ expenseCategoryID }) => expenseCategoryID === id
    );
    return (
        <>
            {category?.expenseFields?.length > 0
                ? (
                    <>
                        <div className="capitalize py-8 font-extrabold text-base">
                            <div
                            className="cursor-pointer flex justify-between bg-white-dark p-2 text-sm"
                            style={{ color: '#333869' }}
                            onClick={() => setShow(!show)}
                            >
                                {category?.categoryName}
                                {' '}
                                - Add More details
                            <span
                            className="text-primary-500 text-sm cursor-pointer pl-1"
                            style={!show ? { transform: 'rotate(-90deg)' } : { transform: 'rotate(0deg)' }}
                            >
                                ▼
                            </span>
                            </div>
                            <hr />
                        </div>
                        {show && (
                        <div className="grid grid-cols-3 col-gap-4 row-gap-4">
                            {category?.expenseFields?.map(
                                (data, num) => (
                                    <ExpenseCategoryField
                                        crew={crew}
                                        key={data?.key}
                                        {...{ data }}
                                        index={index}
                                        num={num}
                                        checkIn={checkIn}
                                        checkOut={checkOut}
                                    />
                                )
                            )}
                            {category?.categoryName === 'Hotel'
                                && (
                                    <Field
                                        name="noOfDays"
                                        component={InputFieldComponent}
                                        className="w-full"
                                        rounded
                                        disabled
                                        value={checkOut && checkIn ? NoOfdays : ''}
                                        label="No. of Days"
                                    />
                            )}
                        </div>
                        )}
                    </>
                ) : ''}
        </>
    );
};

export default ExpenseFieldForm;
